module.exports = __webpack_public_path__ + "8e6fc60fa23bf9fdace300a03fcc5091.svg";